import SearchIcon from '@mui/icons-material/Search';
import { Box, Divider, IconButton, InputBase, Paper, Typography } from '@mui/material';
import React from 'react';

interface SearchInputProps {
  placeholder: string;
  text: string;
  action: (search: string) => void;
  count: number;
}

const SearchInput: React.FC<SearchInputProps> = ({ text: searchTerm, action: setSearchTerm, count, placeholder }) => {
  return (
    <Paper
      component="form"
      onSubmit={(e) => e.preventDefault()}
      sx={{ display: 'flex', alignItems: 'center', width: 400 }}
    >
      <IconButton sx={{ p: '10px' }} aria-label="search">
        <SearchIcon />
      </IconButton>
      <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={placeholder}
        inputProps={{ 'aria-label': placeholder }}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {searchTerm && (
        <>
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '50px', height: '30px' }}>
            <Typography variant="body2">{count}</Typography>
          </Box>
        </>
      )}
    </Paper>
  );
};

export default SearchInput;
